import { jsx as t } from "react/jsx-runtime";
import { CloseIcon as n } from "../../../icons/close-icon.mjs";
import { twMerge as m } from "tailwind-merge";
function i({ onClick: r, closeButtonClassName: e, isDisabled: o }) {
  return /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: m(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        o && "cursor-not-allowed",
        e
      ),
      onClick: r,
      disabled: o,
      children: /* @__PURE__ */ t(n, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
export {
  i as CloseButton
};
